/**
 * Configuration object containing the path to our font, in json.
 */
const fonts = {
	avantGardeBold: './fonts/avant_garde_bold.json'
}

export default fonts
